import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import dayjs from 'vue-dayjs'
import axios from 'axios'
import VueAxios from 'vue-axios'
import AOS from 'aos'
import { register } from 'swiper/element/bundle';
import VueSocketIO from 'vue-socket.io';
import socketio from 'socket.io-client';

import 'aos/dist/aos.css'


import {url} from './global/index'; 

const SocketInstance = socketio.connect(url.replace("/api",""));
Vue.use(new VueSocketIO({
  debug: true,
  connection: SocketInstance,
  options: {
    autoConnect: true,
    reconnection: true
  }
}));

Vue.use(dayjs)

Vue.use(VueAxios, axios)

axios.defaults.baseURL =url;

Vue.config.productionTip = false
register();

new Vue({
  created() {
    AOS.init();
  },
  router,
  store, 
  render: h => h(App),
}).$mount('#app')
